var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-card",attrs:{"elevation":"0"}},[_vm._t("image"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }